<!-- Item List Table -->
<div class="card table-container" >
        <div class="card-body" id="item_card_body">
            <!-- <div id="item_container"> -->
    
            <table class="" id="c_item_table">
                <!-- <thead> -->
                <tr id="c_item_table_header" class="cust-table-header">
                
                    <th (click)="sort('itemName')" style="flex: 0 0 100px;" id="itemName">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'itemName' && isDesc), 'fas fa-sort-up': (column == 'itemName' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'ItemsList.itemName' | translate }}
                    </th>
                    <th (click)="sort('itemType')" style="flex: 0 0 100px;" id="itemType">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'itemType' && isDesc), 'fas fa-sort-up': (column == 'itemType' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'ItemsList.itemType' | translate }}
                    </th>
                    <th style="flex: 0 0 100px;" id="itemIdentifier">
                        {{ 'ItemsList.itemIdentifier' | translate }}
                    </th>
                    <th (click)="sort('statusType')" style="flex: 0 0 100px;" id="statusType">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'statusType' && isDesc), 'fas fa-sort-up': (column == 'statusType' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'ItemsList.itemStatus' | translate }}
                    </th>
                    <th (click)="sort('sla')" style="flex: 0 0 100px;" id="sla">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'sla' && isDesc), 'fas fa-sort-up': (column == 'sla' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'ItemsList.serviceLevel' | translate }}
                    </th>
                
                </tr>
                <tbody *ngIf="isItemslist" appInfinteScroll (scrolledEnd)="scrollEnd()" (scrolledCur)="scrollCur()"> 
                <tr class="table-body" *ngFor="let item of itemsBasicInfoResponse; let i=index;trackBy: trackByItems" 
                id="c_item_table_body" routerLink="{{ item.itemId }}">
                    <td>{{ item.itemName }}</td>
                    <td>{{ item.itemTypeName }}</td>
                    <td>{{ item.itemIdentifier }}</td>
                    <td>{{ item.itemStatus }}</td>
                    <td>{{ item.serviceLevel }}</td>
                </tr>
                                
                </tbody>
                <!-- If no record found on global search -->
                <tbody *ngIf="!isItemslist && !isLoading && !spinnerStart">
                    <tr class="norecords"> 
                        <td colspan="5" class="text-center">{{ 'ItemsList.noRecords' | translate }}</td>
                    </tr>
                </tbody>
             
            </table>
        </div>
        <!-- Spinner -->
        <div class="text-center col-12" id="sd_store_item_loading ">
            <div *ngIf="isLoading || spinnerStart" id="spinner" role="progressbar">
                <zsd-spinner></zsd-spinner>
            </div>
        </div>
    </div>

    <!-- End of On Scroll Load Div -->
    <div *ngIf="scrollEndReached &&itemsBasicInfoResponse.length > 20" class="text-center" id="no_requests_message">
        <div class="card">
        <div class="card-body" id="sd_request_list_no_request_message">
                {{ 'CommonStrings.endOfScroll' | translate }}
        </div>
    </div>
    </div>
